module.exports = __webpack_public_path__ + "img/cadeado.a62f18db.svg";